module.exports = __webpack_public_path__ + "static/media/logout.31b77035.svg";